import { createContext, useContext, useEffect, useState } from "react";

interface ThemeContextType {
  addTheme: string;
  setAddTheme: (theme: string) => void;
  clearWithTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [addTheme, setAddTheme] = useState(() => {
    return localStorage.getItem("layoutMode") || "eclipse";
  });

  useEffect(() => {
    if (!addTheme) return;
    
    document.body.classList.remove("light", "dark", "eclipse");
    document.body.classList.add(addTheme);
    localStorage.setItem("layoutMode", addTheme);
  }, [addTheme]);

  const clearWithTheme = () => {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
        if (key !== 'layoutMode') {
            localStorage.removeItem(key);
        }
    });
    // Don't reset theme - preserve user's theme preference
    // setAddTheme("eclipse"); // Removed this line
  }

  return (
    <ThemeContext.Provider value={{ addTheme, setAddTheme, clearWithTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme debe ser usado dentro de un ThemeProvider");
  }
  return context;
};
